<template>
    <div class="root-container">
        <div class="left-pane">
            <MenuPane />
        </div>
        <div class="center-pane">
            <div class="profile-pic-container">
                <img :src="profilePicSrc" alt="profile pic" class="profile-pic" />
            </div>
            <div class="profile-info-container">
                <p>@{{ username }}</p>
            </div>
        </div>
        <div class="right-pane">
        </div>
    </div>
</template>

<script>
import MenuPane from '@/components/MenuPane.vue';
import UserService from '@/service/user.js';


export default {
    name: 'Profile',
    components: {
        MenuPane,
    },
    data() {
        let userService = new UserService();
        return {
            userService: userService,
            user: null
        }
    },
    async mounted() {
        let res = await this.userService.getMe();
        if (res.error === null) {
            this.user = res.data;
        } else if (res.error?.status === 401) {
            this.$router.push('/');
        } else {
            console.error('Error fetching me:', res.error);
        }
    },
    computed: {
        profilePicSrc() {
            if (this.user === null) {
                return '';
            }
            if (this.user.profile_pic) {
                return `data:image/*;base64,${this.user.profile_pic}`;
            }
            return '';
        },
        username() {
            if (this.user === null) {
                return '';
            }
            return this.user.username;
        }
    }
}
</script>

<style lang="scss" scoped>
$color-bg-primary: black;
$color-border: #333;

.root-container {
    display: flex;
    width: 100vw;
    min-height: 100vh;
    background-color: $color-bg-primary;

    .left-pane {
        display: flex;
        width: 20%;
        background-color: $color-bg-primary;
        border-right: 1px solid $color-border;
        flex-direction: column;
    }

    .center-pane {
        display: flex;
        width: 50%;
        background-color: $color-bg-primary;
        flex-direction: column;
        border-right: 1px solid $color-border;
        overflow-y: auto;
        height: 100vh;

        .profile-pic-container {
            display: flex;
            margin-left: 5%;
            margin-top: 5%;

            .profile-pic {
                width: 125px;
                height: 125px;
                border-radius: 50%;
                object-fit: cover;
            }
        }

        .profile-info-container {
            display: flex;
            flex-direction: column;
            margin-left: calc(5% + 0.3 * 125px);
            color: white;
        }
    }
    .right-pane{
        width: 30%;
        background-color:black;
    }

}
@media (max-width: 768px) {
    .left-pane {
        display: none !important;
    }

    .right-pane {
        display: none !important;
    }

    .center-pane {
        width: 100% !important;
    }
}
</style>
